import { render, staticRenderFns } from "./indexTitle2.vue?vue&type=template&id=0a6a0cba&scoped=true&"
import script from "./indexTitle2.vue?vue&type=script&lang=js&"
export * from "./indexTitle2.vue?vue&type=script&lang=js&"
import style0 from "./indexTitle2.vue?vue&type=style&index=0&id=0a6a0cba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a0cba",
  null
  
)

export default component.exports